import React from 'react'

import { RadioGroup } from '@headlessui/react'
import { Controller, UseFormReturn } from 'react-hook-form'
import classNames from 'classnames'
import TableParcelas from '../tableParcelas'
import { validateData } from '../../utils/date'

import {
    InputsFormStep2,
    PaymentData,
} from '../../Pages/PagamentoCriar/interfaces'
import {
    Container,
    ExplainText,
    Leftside,
    OptionsDiv,
    PaymentTypeDiv,
    Rightside,
    Type,
} from './styles'

import { TbCalendarTime } from 'react-icons/tb'
import { BiDollarCircle } from 'react-icons/bi'

interface Props {
    submitFormStep2(inputs: InputsFormStep2): void
    formStep2: UseFormReturn<InputsFormStep2, any>
    paymentData: PaymentData
}

export default function Step2({
    paymentData,
    formStep2: {
        control,
        register,

        formState: { errors },

        watch,
    },
}: Props) {
    return (
        <Container className="flex flex-col gap-y-10 2xl:flex-row w-full justify-between 2xl:gap-x-16 col-span-2">
            {/* <h3 >Como o seu cliente poderá pagar?</h3> */}

            <Leftside className="md:min-w-max">
                <PaymentTypeDiv>
                    <Controller
                        defaultValue={0}
                        name="tipoPagamento"
                        control={control}
                        rules={{
                            required: 'Escolha o tipo do pagamento',
                        }}
                        render={({ field: { value, ...field } }) => (
                            <RadioGroup
                                {...field}
                                defaultValue={0}
                                value={value}
                            >
                                <RadioGroup.Label className="text-2xl text-gray-900">
                                    Como será o pagamento?
                                </RadioGroup.Label>
                                <OptionsDiv>
                                    <RadioGroup.Option value={0}>
                                        {({ checked }) => (
                                            <Type
                                                className={classNames(
                                                    'flex items-center justify-center rounded-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-blue-200 focus:ring-offset-2 focus:outline-none',
                                                    {
                                                        'border-transparent shadow-md outline-none ring-2 ring-blue-500 bg-blue-50':
                                                            checked,
                                                    },
                                                    {
                                                        'hover:border-blue-100 border border-gray-300':
                                                            !checked,
                                                    }
                                                )}
                                            >
                                                <BiDollarCircle
                                                    className={classNames(
                                                        'text-gray-700'
                                                    )}
                                                />
                                                <p
                                                    className={classNames(
                                                        'text-base',
                                                        {
                                                            'text-blue-600':
                                                                checked,
                                                        }
                                                    )}
                                                >
                                                    À vista
                                                    <br /> ou parcelado{' '}
                                                </p>
                                            </Type>
                                        )}
                                    </RadioGroup.Option>
                                    <RadioGroup.Option value={1}>
                                        {({ checked }) => (
                                            <Type
                                                className={classNames(
                                                    'flex items-center justify-center rounded-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-blue-200 focus:ring-offset-2 focus:outline-none',
                                                    {
                                                        'border-transparent shadow-md outline-none ring-2 ring-blue-500 bg-blue-50':
                                                            checked,
                                                    },
                                                    {
                                                        'hover:border-blue-100 border border-gray-300':
                                                            !checked,
                                                    }
                                                )}
                                            >
                                                <TbCalendarTime
                                                    className={classNames(
                                                        'text-gray-700'
                                                    )}
                                                />
                                                <p
                                                    className={classNames(
                                                        'text-base',
                                                        {
                                                            'text-blue-600':
                                                                checked,
                                                        }
                                                    )}
                                                >
                                                    Recorrência
                                                </p>
                                            </Type>
                                        )}
                                    </RadioGroup.Option>
                                </OptionsDiv>
                            </RadioGroup>
                        )}
                    />

                    {errors.tipoPagamento &&
                        errors.tipoPagamento.type === 'required' && (
                            <span className="text-red-500 text-sm">
                                {errors.tipoPagamento.message}
                            </span>
                        )}
                </PaymentTypeDiv>

                <ExplainText className="">
                    {watch('tipoPagamento') === 0
                        ? 'O pagamento será apenas uma vez, podendo ser parcelado conforme definido.'
                        : `Pagamentos recorrentes com frequência personalizada, todas com o valor de ${Number(
                              paymentData.valor
                          ).toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                          })}`}
                </ExplainText>
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center max-w-md">
                    {Number(watch('tipoPagamento')) === 0 && (
                        <div className="block mb-2 sm:mb-0">
                            <label
                                htmlFor="quantParcela"
                                className="text-base text-gray-700 mb-2 block"
                            >
                                Quantidade de parcelas:{' '}
                            </label>
                            <select
                                defaultValue={1}
                                {...register('quantParcelas')}
                                className="appearance-none rounded-lg flex-1 border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                id=""
                            >
                                <option
                                    className="block py-2 px-4 bg-white hover:bg-blue-600 cursor-pointer"
                                    value={1}
                                >
                                    À vista
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600 cursor-pointer"
                                    value={2}
                                >
                                    Em até 2x
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600"
                                    value={3}
                                >
                                    Em até 3x
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600"
                                    value={4}
                                >
                                    Em até 4x
                                </option>
                                <option className="py-2 px-4" value={5}>
                                    Em até 5x
                                </option>
                                <option className="py-2 px-4" value={6}>
                                    Em até 6x
                                </option>
                                <option className="py-2 px-4" value={7}>
                                    Em até 7x
                                </option>
                                <option className="py-2 px-4" value={8}>
                                    Em até 8x
                                </option>
                                <option className="py-2 px-4" value={9}>
                                    Em até 9x
                                </option>
                                <option className="py-2 px-4" value={10}>
                                    Em até 10x
                                </option>
                            </select>
                            {/* <Controller defaultValue={1} control={control} name='quantParcelas' render={({ field }) => (
                        <Select
                            {...field}
                            id="quantParcela"
                            variant='outlined'
                            className='w-full'
                        >
                            <MenuItem value={1}>À vista</MenuItem>
                            <MenuItem value={2}>Em até 2x</MenuItem>
                            <MenuItem value={3}>Em até 3x</MenuItem>
                            <MenuItem value={4}>Em até 4x</MenuItem>
                            <MenuItem value={5}>Em até 5x</MenuItem>
                            <MenuItem value={6}>Em até 6x</MenuItem>
                            <MenuItem value={7}>Em até 7x</MenuItem>
                            <MenuItem value={8}>Em até 8x</MenuItem>
                            <MenuItem value={9}>Em até 9x</MenuItem>
                            <MenuItem value={10}>Em até 10x</MenuItem>
                        </Select>
                    )} /> */}
                        </div>
                    )}
                    {Number(watch('tipoPagamento')) === 1 && (
                        <div className="block mb-2 sm:mb-0">
                            <label
                                htmlFor="frequenciaCobranca"
                                className="text-base text-gray-700 mb-2 block"
                            >
                                Frequência da cobrança:{' '}
                            </label>
                            <select
                                defaultValue={1}
                                {...register('frequenciaPagamento')}
                                className="appearance-none rounded-lg flex-1 border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                id=""
                            >
                                <option value={1}>Mensal</option>
                                <option value={3}>Trimestral</option>
                                <option value={6}>Semestral</option>
                                <option value={12}>Anual</option>
                            </select>
                            {/* <Controller defaultValue={1} control={control} name='frequenciaCobranca' render={({ field }) => (
                        <Select
                            {...field}
                            id="frequenciaCobranca"
                            variant='outlined'
                            className='w-full'
                        >
                            <MenuItem value={1}>Mensal</MenuItem>
                            <MenuItem value={3}>Trimestral</MenuItem>
                            <MenuItem value={6}>Semestral</MenuItem>
                            <MenuItem value={12}>Anual</MenuItem>
                        </Select>
                    )} /> */}
                        </div>
                    )}
                    <div className="">
                        <label
                            htmlFor="data"
                            className="text-base text-gray-700 mb-2 block"
                        >
                            {Number(watch('tipoPagamento')) === 0 &&
                            Number(watch('quantParcelas')) === 1
                                ? 'Vencimento do pagamento'
                                : Number(watch('tipoPagamento')) === 0
                                ? 'Vencimento da 1ª parcela'
                                : 'Vencimento do 1º pagamento'}{' '}
                        </label>
                        <input
                            defaultValue=""
                            id="data"
                            {...register('dataLiquidacao', {
                                required: false,
                                validate: (value) => validateData(value),
                            })}
                            className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm py-2 px-4 focus:border-transparent"
                            type="date"
                        />
                        {errors.dataLiquidacao &&
                            errors.dataLiquidacao.type === 'required' && (
                                <span className="hook-error">
                                    Data inválida
                                </span>
                            )}
                        {errors.dataLiquidacao &&
                            errors.dataLiquidacao.type === 'validate' && (
                                <span className="hook-error">
                                    Data inválida
                                </span>
                            )}
                    </div>
                </div>
            </Leftside>

            {/* {renderSelect()} */}
            <Rightside className="max-w-lg">
                {/* <p className='text-2xl text-gray-900 mb-4'>Valor liquido a receber R$ 100,00</p> */}
                {paymentData.valor !== 0 &&
                    paymentData.valor &&
                    watch('tipoPagamento') === 0 && (
                        <TableParcelas
                            data_Liquidacao={watch('dataLiquidacao')}
                            valueLink={Number(paymentData.valor)}
                            quantParcelas={Number(watch('quantParcelas'))}
                        />
                    )}
            </Rightside>
        </Container>
    )
}
